import React from "react";

import { Route, Switch, useRouteMatch } from "react-router-dom";
import { default as TraineeDetail } from "./trainee-detail";
import { default as ContainerRoute } from "@components/common/routing/container-route";

export default function MyWork({ responsiveStyles = {} }) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={path}
        component={TraineeDetail}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>
    </Switch>
  );
}
